import React from 'react';
import {
  FieldLabel,
  FormProps,
  getInputField,
  Row,
  RowWrapper,
  Section,
  SectionTitle,
} from '../../../components/AdminFormComponents';

export const OEMDealerSection = (props: FormProps) => {
  const { isSubmitting } = props;
  return (
    <Section>
      <SectionTitle>OEM Details</SectionTitle>
      <RowWrapper>
        <Row>
          <FieldLabel>Dealer Code</FieldLabel>
          {getInputField('oemDealerCode', false, false, isSubmitting)}
        </Row>

        <Row>
          <FieldLabel>Area</FieldLabel>
          {getInputField('oemAreaCode', false, false, isSubmitting)}
        </Row>

        <Row>
          <FieldLabel>Sub Area</FieldLabel>
          {getInputField('oemSubAreaCode', false, false, isSubmitting)}
        </Row>
      </RowWrapper>
    </Section>
  );
};
